import { defineComponent, openBlock, createElementBlock, normalizeStyle, createElementVNode, createCommentVNode } from 'vue';
import _export_sfc from '../_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "FillMinimize2",
  props: {
    gradient: {
      type: Boolean
    },
    opacity: {
      type: [Number, String],
      default: "0.35"
    },
    startColor: {
      type: String,
      default: ""
    },
    iconId: [String, Number]
  }
});
const _hoisted_1 = { key: 0 };
const _hoisted_2 = ["id"];
const _hoisted_3 = /* @__PURE__ */ createElementVNode("stop", {
  "stop-color": "currentColor",
  offset: "100%"
}, null, -1);
const _hoisted_4 = ["fill"];
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", { d: "M21,3 C21.5522847,3 22,3.42284218 22,3.94444444 L22,10.5555556 L20,10.5555556 L20,4.88888889 L4,4.88888889 L4,18.1111111 L10,18.1111111 L10,20 L3,20 C2.44771525,20 2,19.5771578 2,19.0555556 L2,3.94444444 C2,3.42284218 2.44771525,3 3,3 L21,3 Z M6.707,6.11005556 L8.957,8.23505556 L11,6.30555556 L11,11.5 L5.5,11.5 L7.543,9.5705 L5.293,7.4455 L6.707,6.11005556 Z" }, null, -1);
const _hoisted_6 = /* @__PURE__ */ createElementVNode("path", {
  d: "M21,12.4444444 C21.5522847,12.4444444 22,12.8672866 22,13.3888889 L22,19.0555556 C22,19.5771578 21.5522847,20 21,20 L13,20 C12.4477153,20 12,19.5771578 12,19.0555556 L12,13.3888889 C12,12.8672866 12.4477153,12.4444444 13,12.4444444 L21,12.4444444 Z",
  style: { "opacity": "var(--fill-opacity)" }
}, null, -1);
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": "Minimize2",
    role: "presentation",
    class: "icon-fill",
    style: normalizeStyle({
      "--fill-opacity": _ctx.opacity
    }),
    fill: "currentColor"
  }, [
    _ctx.gradient ? (openBlock(), createElementBlock("defs", _hoisted_1, [
      createElementVNode("linearGradient", {
        id: _ctx.iconId,
        x1: "50%",
        y1: "0%",
        x2: "50%",
        y2: "100%",
        gradientUnits: "userSpaceOnUse"
      }, [
        createElementVNode("stop", {
          style: normalizeStyle({
            stopColor: _ctx.startColor ? _ctx.startColor : "var(--icon-start-color)"
          }),
          offset: "0%"
        }, null, 4),
        _hoisted_3
      ], 8, _hoisted_2)
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", {
      stroke: "none",
      "stroke-width": "1",
      fill: _ctx.gradient ? "url(#" + _ctx.iconId + ")" : "currentColor",
      "fill-rule": "evenodd"
    }, _hoisted_7, 8, _hoisted_4)
  ], 4);
}
var Minimize2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Minimize2 as default };
